{
  "CHANGELOG": {
    "VIEW_ALL": "Alle ansehen"
  }
}
